export default __webpack_public_path__ + "static/3-37d274a43e9d091d8e61cf033e97d0c5.jpg";